/*
  "You may also like" card (snippets/leza-product-ymal-card.liquid).
  A colour swatch selects the variant with that colour and the card's other options unchanged. When that
  exact variant exists it becomes the one Add submits: image (if the variant has one), price, compare-at
  price and both links follow it, and Add is enabled only if it is available ("Sold out" otherwise).
  When no such variant exists Add is disabled ("Unavailable"); another variant is never substituted.
  Adding is Dawn's product-form (cart drawer, spinner, errors).
*/
(() => {
  if (window.lezaYmalReady) return;
  window.lezaYmalReady = true;

  const variantsOf = (card) => {
    if (!card.lezaVariants) {
      try {
        card.lezaVariants = JSON.parse(card.querySelector('[data-leza-ymal-variants]').textContent);
      } catch (error) {
        card.lezaVariants = [];
      }
    }
    return card.lezaVariants;
  };

  const setAdd = (card, state) => {
    const productForm = card.querySelector('product-form');
    const button = card.querySelector('.leza-ymal__add');
    const label = card.querySelector('[data-leza-ymal-label]');
    if (!button || !label) return;
    // Clear what an earlier failed add may have left (Dawn's sold-out message, aria-disabled).
    if (productForm) productForm.error = false;
    button.removeAttribute('aria-disabled');
    button.querySelector('.sold-out-message')?.classList.add('hidden');
    label.classList.remove('hidden');
    card.querySelector('.leza-ymal__error')?.setAttribute('hidden', '');

    if (state === 'add') {
      button.disabled = false;
      label.replaceChildren();
      const plus = document.createElement('span');
      plus.setAttribute('aria-hidden', 'true');
      plus.textContent = '+ ';
      label.append(plus, card.dataset.add);
    } else {
      button.disabled = true;
      label.textContent = state === 'sold-out' ? card.dataset.soldOut : card.dataset.unavailable;
    }
  };

  const select = (card, swatch) => {
    const index = Number(card.dataset.colorIndex);
    const variants = variantsOf(card);
    const input = card.querySelector('input[name="id"]');
    if (!input || Number.isNaN(index) || !variants.length) return;

    card.querySelectorAll('.leza-ymal__swatch').forEach((button) => button.setAttribute('aria-pressed', String(button === swatch)));

    const current = variants.find((variant) => String(variant.id) === input.dataset.selected) || variants.find((variant) => String(variant.id) === input.value) || variants[0];
    const wanted = current.options.slice();
    wanted[index] = swatch.dataset.value;
    const match = variants.find((variant) => variant.options.every((value, i) => value === wanted[i]));

    if (!match) {
      input.disabled = true;
      setAdd(card, 'unavailable');
      return;
    }

    input.value = String(match.id);
    input.dataset.selected = String(match.id);
    input.disabled = !match.available;
    card.querySelectorAll('[data-leza-ymal-link]').forEach((link) => (link.href = match.url));

    card.querySelector('[data-leza-ymal-price]').textContent = match.price;
    const compare = card.querySelector('[data-leza-ymal-compare]');
    compare.textContent = match.compare || '';
    compare.hidden = !match.compare;

    const image = card.querySelector('.leza-ymal__image');
    if (image && match.image) {
      image.srcset = match.srcset || '';
      image.src = match.image;
    }

    setAdd(card, match.available ? 'add' : 'sold-out');
  };

  document.addEventListener('click', (event) => {
    const swatch = event.target.closest('.leza-ymal__swatch');
    const card = swatch && swatch.closest('[data-leza-ymal-card]');
    if (card) select(card, swatch);
  });
})();
